import { render, staticRenderFns } from "./BtnUpload.vue?vue&type=template&id=fef46cca&"
import script from "./BtnUpload.vue?vue&type=script&lang=js&"
export * from "./BtnUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports